// extracted by mini-css-extract-plugin
module.exports = {"base":"SelectInput_base__2u8KA","moreRightSpaces":"SelectInput_moreRightSpaces__ZHK6_","errorInput":"SelectInput_errorInput__tr9eZ"};